import request from '../../../axios';
import { countryType } from './type';
export const getStates = async () => {
  const data: { data: countryType[] } = await request.get(
    `/api/v2/base/neighbor-countries`,
  );
  const statesIran = data.data.find(item => item.name === "ایران")?.state
  return statesIran ?? [];
};
